import { navigatorLock, processLock } from '@supabase/supabase-js';

// Coordinate refresh-token rotation across tabs. Sandboxed embeds can expose
// navigator.locks but reject its use; only that case uses the process fallback.
export async function authLock(name, timeout, fn) {
  let started = false;
  const run = () => {
    started = true;
    return fn();
  };
  try {
    if (typeof navigator === 'undefined' || !navigator.locks?.request) {
      return await processLock(name, timeout, run);
    }
    return await navigatorLock(name, timeout, run);
  } catch (error) {
    if (!started && error?.name === 'SecurityError') {
      return processLock(name, timeout, fn);
    }
    // Never retry an operation that already ran, or bypass a busy lock.
    throw error;
  }
}
